import React from "react";
import HeroContent from "./hero-content/HeroContent";

function HeroHome() {
  return (
    <section className="relative px-0 wrapper">
      <div className="mx-auto ">
        <div className="flex items-center mb-20">
          <div className="w-full flex bg-hero">
            <div className="pb-12 md:pb-16 pt-20 md:mt-36 md:pt-20 ">
              <HeroContent />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default HeroHome;
